var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 417.012,
    height: 550.016,
    viewBox: "0 0 417.012 550.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1001",
    "data-name": "Rectangle 1001",
    width: 417.012,
    height: 550.016,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M138.253,309.276a73.746,73.746,0,1,1,71.316,54.939h0a73.862,73.862,0,0,1-71.312-54.939m24.491-194.184c-97.532,25.9-155.611,126-129.725,223.579s125.94,155.688,223.472,129.788,155.613-126,129.725-223.58A182.484,182.484,0,0,0,162.744,115.092",
    transform: "translate(-26.859 -108.93)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-30.677 -40.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    transform: "translate(30.677 40.461)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2650",
    "data-name": "Group 2650",
    transform: "translate(43.433 176.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2649",
    "data-name": "Group 2649",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    transform: "translate(-3.432 -3.226)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 186,
    r: 186,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 186,
    r: 185.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    transform: "translate(8.088 8.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3436",
    "data-name": "Group 3436",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    transform: "translate(-0.088 -0.081)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 79.5,
    fill: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.afefcf9dbc2656595b2f62616d5c6cf0.svg";
export { ForwardRef as ReactComponent };